<template>
  <div id="app">
    <div class="headers">
      <div class="left">
        <img src="./assets/logo.png" alt="" class="left_img">
        <div>帮助中心</div>
      </div>
      <div class="right">
<!--        Admin-->
        <el-dropdown>
          <i class="el-icon-setting" style="margin-right: 15px;color: #fff;"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span>{{user.userName||'Admin'}}</span>
      </div>
    </div>
    <div class="content">
      <div class="con-left">
        <ul>
          <li :class="{'active':activeName.name==item.name}" v-for="(item,i) in routerList" @click="goNext(item)" :key="i" >
            {{item.meta.title}}
          </li>
        </ul>
      </div>
      <div class="con-right">
        <div class="position">当前位置：{{activeName.meta.title}}</div>
        <div class="contentView">
          <keep-alive >
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>

      </div>

    </div>


  </div>

</template>

<script>
  import router from "./router";
  import {fetchGet,fetchPost} from '@/api/request'
  import config from "@/api/config";
  import {getCookie} from '@/utils'

  export default {
    name: 'App',
    components: {},
    data() {
      return {
        activeName: '',
        user:{}
      };
    },
    computed: {
      routerList() {
        return router.options.routes.filter(item => !item.meta.hidden)
      }
    },
    created() {
      this.activeName = this.$route

        this.init()

    },
    methods: {
      goNext(item) {
        this.$router.push({name: item.name})
        this.activeName = item
      },
      go() {
        history.go(-1)
      },
      init(){
        // sso_token : getCookie("com.gooagoo.passpart.sso.token.name")
        // console.log(getCookie("com.gooagoo.passpart.sso.token.name"),'getCookie("com.gooagoo.passpart.sso.token.name")')
        // console.log(getCookie("user_token"))



        fetchGet(`index/requestForwarding?sso_token=${getCookie("user_token")}&optFlag=login`).then(res => {

          if(res.data){
            this.user=res.data||{}
          }else{
            this.user={}
          }


        })


      },
      logout(){
        fetchGet(`index/requestForwarding?sso_token=${getCookie("user_token")}&optFlag=loginOut`).then(res => {
          // console.log(res)
          let href=location.href
          if(href.includes('.test.')){
            window.location.href = 'https://passport.test.goago.cn/index.html'
          }else{
            window.location.href = 'https://passport.gooagoo.com/index.html'
          }

        })
      }

    },
    watch: {
      $route(){
        this.activeName = this.$route

      }
    },

  }
</script>

<style scoped lang="less">

  #app {
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    overflow: hidden;
  }

  .headers {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: 62px;
    opacity: 1;
    background: #161e2d;
    box-sizing: border-box;
  }

  .content {
    width: 100%;
    height: calc(100% - 62px);
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .con-left {
    width: 256px;
    height: 100%;
    background: #EDEFF2;
    overflow: hidden;
    padding: 24px;
    box-sizing: border-box;
  }

  .con-left ul {
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
  }

  .con-left ul li {
    /*width: 100%;*/
    height: 36px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    border-radius: 5px;
    cursor: pointer;
  }

  .con-left ul li.active {
    color: #fff;
    background: #1677FF;
  }

  .con-right {
    flex: 1;
    display: flex;
    flex-direction: column;

    .position {
      width: 100%;
      height: 46px;
      flex: 0 0 46px;
      border-bottom: 1px solid #E7E9EB;
      display: flex;
      align-items: center;
      padding-left: 24px;
      font-size: 14px;
      color: #999999;
    }

    .contentView {
      padding: 0 24px;
      display: flex;
      flex: 1;
    }
  }

  .left {
    opacity: 1;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
    line-height: 25px;
    display: flex;

  }

  .left_img {
    margin-left: 24px;
    width: 20px;
    height: 20px;
    margin-right: 14px;
  }

  .right {
    opacity: 1;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    line-height: 20px;
    margin-right: 24px;
    display: flex;
  }
</style>
